import {  useEffect, useState } from "react"
import { sortDirectionType } from "../api/api"




export const useGetSort =(sort_fields:(number|undefined)[]=[],fetchSortedData?:Function)=>{
    const [sortChecked,setSort]=useState({selectedIndex:-1,trigger:false ,up:false,down:false})

    useEffect(()=>{
        if (sortChecked) {
         
          if (fetchSortedData && sortChecked.selectedIndex>-1) {
            let field_id= sort_fields?.[ sortChecked.selectedIndex]
            let sort_direction:sortDirectionType=sortChecked.down? 'DESC':sortChecked.up?'ASC':'ASC'

            fetchSortedData( field_id,sort_direction)
          }
          
        }
      },[sortChecked ])

      const handleSort =(index:number) =>{
        
        if (sort_fields?.[index]){
        setSort((pre:any)=>{
          if (index === pre.selectedIndex){
            return ({...pre,selectedIndex:index,trigger:!pre.trigger,up:!pre.up,down:!pre.down})
          }
          else {
           
            return ({...pre,selectedIndex:index,trigger:!pre.trigger,up:true,down:false})
          }
        })
      }
        
        
      }

    return { sortChecked ,handleSort}
}